<template>
  <!-- 单选题 -->
  <div class="question-item">
    <div class="title-box">
      <span class="line-name">选项</span>
      <span class="line-dec" v-if="!readOnly">单选题的选项范围从{{ minOptions }}-{{ maxOptions }}个</span>
    </div>
    <div class="single option">
      <div class="option-content">
        <template v-for="(item, index) in optionsCopy">
          <div class="option-item" :key="item['exam_questions_options.ds_order']" v-if="item['exam_questions_options.ds_deleted'] !== 1">
            <div class="item-line1">
              <div class="item-order">
                <el-radio
                  :disabled="readOnly"
                  v-model="checkedOrder"
                  @change="changeCheck(item['exam_questions_options.ds_order'])"
                  :label="item['exam_questions_options.ds_order']"
                >
                </el-radio>
              </div>
              <div class="item-text">
                <el-input
                  v-if="!readOnly"
                  :disabled="readOnly"
                  v-model="item['exam_questions_options.name']"
                  placeholder="请输入内容"
                  :maxlength="inputlength"
                />
                <el-input
                  v-else
                  :disabled="readOnly"
                  v-model="item['exam_questions_options.name']"
                  placeholder="请输入内容"
                  :maxlength="inputlength"
                  :autosize="readOnly"
                  type="textarea"
                />
              </div>
              <div class="item-del" v-if="!readOnly">
                <i class="el-icon-error" @click="deleteOption(item, index)"></i>
              </div>
            </div>
            <div class="item-line2">
              <DsfQuestionUpLoadImg
                :fileList="item['exam_questions_options.imgs']"
                :optionsId="item['exam_questions_options.ds_order']"
                :readOnly="readOnly"
                @get-imglist="getImgList"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="option-add" v-if="!readOnly">
        <DsfButton type="plain" icon="add" @click="addOption">添加选项</DsfButton>
      </div>
    </div>
  </div>
</template>

<script>
import DsfQuestionUpLoadImg from "./UploadImg.vue";
export default {
  name: "DsfSingle",
  mixins: [$mixins.examquestion],
  components: { DsfQuestionUpLoadImg },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
   

    //是否显示输入字数统计
    showWordLimit: {
      type: Boolean,
      default: false,
    },
    exam_questions_options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    optionsCopy() {
      var list = this.exam_questions_options.filter((item) => item["exam_questions_options.ds_deleted"] !== 1);
      return list;
    },
  },
  data() {
    return {
      checkedOrder: "",
      dsorder: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.exam_questions_options.forEach((item, index) => {
        this.$set(this.exam_questions_options[index], "exam_questions_options.ds_order", index);
        this.$set(this.exam_questions_options[index], "type", "single");
      });
      if (!this.readOnly && !this.$route.query.id && this.exam_questions_options.length <= 0) {
        this.init();
      }
      if (this.$route.query.id && this.exam_questions_options?.length > 0) {
        this.exam_questions_options.forEach((item, index) => {
          if (item["exam_questions_options.is_right"]?.value == 1) {
            this.checkedOrder = item["exam_questions_options.ds_order"];
          }
        });
      }
    });
  },
  methods: {
    getImgList(imgList, optionsId) {
      this.exam_questions_options.forEach((item, index) => {
        if (item["exam_questions_options.ds_order"] == optionsId) {
          this.exam_questions_options[index]["exam_questions_options.imgs"] = JSON.stringify(imgList);
        }
      });
    },
    changeCheck(val) {},
    addOption() {
      var order = this.exam_questions_options.length;

      if (order < this.maxOptions) {
        this.dsorder += 1;
        this.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.imgs": "[]",
          "exam_questions_options.ds_deleted": 0,
          "exam_questions_options.ds_order": this.dsorder,
          "exam_questions_options.is_right": { text: "否", value: 0 },
          type: "single",
        });
      } else {
        dsf.layer.message(`单选题的选项最多为 ${this.maxOptions}个`, false);
      }
    },
    deleteOption(item, index) {
      this.exam_questions_options.forEach((ele, index) => {
        if (ele["exam_questions_options.ds_order"] == item["exam_questions_options.ds_order"]) {
          if (item._id) {
            this.$set(this.exam_questions_options[index], "exam_questions_options.ds_deleted", 1);
            this.$delete(this.exam_questions_options[index], "exam_questions_options.ds_order");
          } else {
            this.exam_questions_options.splice(index, 1);
          }
        }
      });
      this.$emit("validate-single", false);
    },
    checkNull() {
      return this.exam_questions_options.some(
        (item) =>
          (item["exam_questions_options.imgs"] == "[]" || !item["exam_questions_options.imgs"]) &&
          !item["exam_questions_options.name"] &&
          item["exam_questions_options.ds_deleted"] != 1
      );
    },
    checkAnswer() {
      return this.exam_questions_options.some(
        (item) => item["exam_questions_options.is_right"].value == 1 && item["exam_questions_options.ds_deleted"] != 1
      );
    },
    init() {
      for (let i = 0; i < this.minOptions; i++) {
        this.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.ds_deleted": 0,
          "exam_questions_options.imgs": "[]",
          "exam_questions_options.ds_order": i,
          "exam_questions_options.is_right": { text: "否", value: 0 },
          type: "single",
        });
      }
    },

    save() {
      if (this.optionsCopy.length < this.minOptions) {
        dsf.layer.message(`请添加选项，单选题的选项至少为${this.minOptions}个`, false);
        return false;
      }
      var isNull = this.checkNull();
      if (!isNull) {
        var checked = this.checkAnswer();
        if (!checked) {
          dsf.layer.message("请设置正确答案", false);
          return false;
        } else {
          return true;
        }
      } else { 
        dsf.layer.message(`单选题的选项内容没有设置，请先输入内容`, false);
        return false;
      }
    },
  },
  watch: {
    checkedOrder: {
      handler(val) {
        if (val !== "") {
          this.exam_questions_options.forEach((item, index) => {
            if (item["exam_questions_options.ds_deleted"] != 1) {
              if (item["exam_questions_options.ds_order"] == val) {
                this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "是", value: 1 };
              } else {
                this.exam_questions_options[index]["exam_questions_options.is_right"] = { text: "否", value: 0 };
              }
              this.$emit("validate-single", false);
            }
          });
        }
      },
      deep: true,
    },

    exam_questions_options: {
      handler(val) {
        if (this.dsorder == 0) {
          this.dsorder = val.length - 1;
        }
        if (val.length < 1) {
          // this.init();
          this.checkedOrder = "";
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
